import React, { ReactNode } from 'react';
import { PagePackState, PagePackStates } from '../../../../types/api/PagePackState';
import { ICategory } from '../../../../types/ICategory';
import { LinkedTeaserImage } from '../../../../components/molecules/LinkedTeaserImageInLists';
import { ContentHeadline } from '../../ContentHeadline';
import { ContentHeadlineModifier } from '../../ContentHeadline/ContentHeadline';
import { ContentParagraph } from '../../ContentParagraph';
import { Icons } from '../../../../components/atoms/SVG';
import { ExtendedInfoSVG } from '../../ExtendedInfo';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { CategoryLabel } from '../../CategoryLabel';

type TeaserListItemProps = {
  pageLinkUrl: string;
  pageLinkName: string;
  categories?: ICategory[];
  integrated?: boolean;
  packState?: PagePackStates;
  teaserImageUrl?: string;
  description?: string;
  date?: ReactNode;
  headerExtra?: ReactNode;
  footer?: ReactNode;
};

export function TeaserListItem({
  pageLinkUrl,
  pageLinkName,
  categories,
  integrated,
  packState,
  teaserImageUrl,
  description,
  date,
  headerExtra,
  footer,
}: TeaserListItemProps) {
  const { t } = useSonTranslation('glossary');
  const hexColor = categories?.at(0)?.hexColor;

  return (
    <li
      className={`teaser-list__list-item${hexColor ? ' teaser-list__list-item--category-border' : ''}`}
      style={hexColor ? { borderLeftColor: hexColor } : undefined}
    >
      {teaserImageUrl && (
        <div className="teaser-list__item-image-container">
          <LinkedTeaserImage imageSrc={teaserImageUrl} pageLink={pageLinkUrl} />
        </div>
      )}
      <article className="teaser-list__item-main-container">
        <div className="teaser-list__item-text-container">
          <div className="teaser-list__item-headline">
            <div>
              <CategoryLabel className="teaser-list__category font-regular-13-13" categories={categories} />
              <ContentHeadline
                hierarchy={3}
                url={pageLinkUrl}
                title={pageLinkName}
                modifier={ContentHeadlineModifier.NO_MARGIN_BOTTOM}
                stateIndicatorStatus={packState === PagePackState.ONLY_DRAFT_VERSION ? 'red' : undefined}
              />
            </div>
            {integrated && (
              <ExtendedInfoSVG
                helpText={t('integratedPage')}
                tooltipPlacement={TooltipPlacement.RIGHT}
                svgSpriteID={Icons.CONNECTIONS}
              />
            )}
            {headerExtra}
          </div>
          {description && (
            <div className="teaser-list__content-paragraph">
              <ContentParagraph>{description}</ContentParagraph>
            </div>
          )}
          {date}
          {footer}
        </div>
      </article>
    </li>
  );
}
